import backgroundVideo from '#core/assets/video/background.mp4?url';

import classes from './AppRoot.module.css';

export function AppRoot({ children }: React.PropsWithChildren) {
  return (
    <div className={classes.appRoot}>
      <div className={classes.backdrop}>
        <video autoPlay className={classes.backgroundVideo} loop muted playsInline>
          <source src={backgroundVideo} type="video/mp4" />
        </video>
      </div>

      {children}
    </div>
  );
}
